import { breakpointSizes, getBreakpointDown } from '@paywithextend/components'
import { spacing } from 'ext-ui/style/spacing'
import ApproversUpsellSvg from 'ext-ui/svg/illustration/ApproversUpsellSvg'
import React, { useEffect } from 'react'
import { Helmet } from 'react-helmet'
import { useSelector } from 'react-redux'
import LayoutPage from 'src/component-layout/LayoutPage/LayoutPage'
import CardApprovalsBox from 'src/components/CardApprovalsBox/CardApprovalsBox'
import ManagerReviewSettings from 'src/components/ManagerReviewSettings/ManagerReviewSettings'
import NotFoundBackgroundPageContent from 'src/components/NotFoundBackgroundPageContent/NotFoundBackgroundPageContent'
import { useCurrentUser } from 'src/context/UserProvider/useUser'
import SaasUpgradeOrContent from 'src/feature/SaasUpgradeOrContent/SaasUpgradeOrContent'
import { useBackgroundDispatch } from 'src/hooks'
import { useTranslate } from 'src/localization/Trns'
import { UserFeature } from 'src/models/user.models'
import {
  getOrganization,
  getOrganizationCardApprovalsEnabled,
} from 'src/redux/actions/data/organizations.actions'
import {
  selectCardApprovalsEnabled,
  selectCardApprovalsFromState,
  selectOrganizationIdFromRoute,
  selectUserExplicitOrganizationListModelFromState,
} from 'src/redux/selectors/data/organizations.selectors'
import { selectAppName } from 'src/redux/selectors/session.selectors'
import { css } from 'styled-components'

const BusinessRules: React.FC = () => {
  const user = useCurrentUser()
  const organization = useSelector(
    selectUserExplicitOrganizationListModelFromState,
  )
  const organizationId = useSelector(selectOrganizationIdFromRoute)

  const cardApprovalsEnabled = useSelector(selectCardApprovalsEnabled)
  const cardApprovalRules = useSelector(selectCardApprovalsFromState)
  const appName = useSelector(selectAppName)

  const dispatch = useBackgroundDispatch()
  const translate = useTranslate()

  useEffect(() => {
    dispatch(getOrganization(organizationId))
  }, [])

  useEffect(() => {
    if (cardApprovalRules === undefined) {
      dispatch(getOrganizationCardApprovalsEnabled(organizationId))
    }
  }, [cardApprovalRules])

  if (
    user === undefined ||
    !user.hasOrgBookkeeperPermissions ||
    !organization
  ) {
    return <NotFoundBackgroundPageContent />
  }

  return (
    <>
      <Helmet>
        <title>{`Approvers | ${appName}`}</title>
        <meta name="description" content={`Approvers page of ${appName}`} />
      </Helmet>
      {/* TODO: make sure we update to address and use `hasVirtualCardFeatures` */}
      <LayoutPage padding={'none'}>
        <SaasUpgradeOrContent
          illustration={<ApproversUpsellSvg />}
          title={translate('Approvers')}
          description={translate(
            'Enlist help managing finance operations across your organization. Assign an approver for card requests and an approver for reimbursements.',
          )}
          ctaDetailSrc={
            'Upgrade to ${tier} today and delegate approval responsibilities to your team.'
          }
          feature={UserFeature.BUSINESS_RULES}
        >
          <LayoutPage
            addRightShift={false}
            title={<span>{translate('Approvers')}</span>}
          >
            <div
              css={css`
                display: grid;
                grid-template-columns: 1fr 1fr;
                gap: ${spacing(4)};

                ${getBreakpointDown(breakpointSizes.SM)(css`
                  display: flex;
                  flex-direction: column;
                `)}
              `}
            >
              <CardApprovalsBox
                organization={organization}
                cardApprovalRules={cardApprovalRules}
                cardApprovalsEnabled={cardApprovalsEnabled}
                user={user}
              />
              <ManagerReviewSettings organization={organization} user={user} />
            </div>
          </LayoutPage>
        </SaasUpgradeOrContent>
      </LayoutPage>
    </>
  )
}

export default BusinessRules
